import React from 'react';
import { Chip } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';

const CstStatusChip = (params) => {
  let color = 'primary';
  let label = '기회확인';

  if (params.row.useYn === 'Y') {
    switch (params.row.cstGrade) {
      case '1':
        label = "기회확인"
        color = 'info';
        break;
      case '2':
        label = "기회분석"
        color = 'error';
        break;
      case '3':
        label = "매출견적"
        color = 'success';
        break;
      case '4':
        label = "수주품의"
        color = 'secondary';
        break;

      default:
        break;
    }
  } else {
    color = 'default';
    label = '수주실패';
  }

  return (
    <Chip
      size="small"
      icon={<CircleIcon />}
      label={label}
      variant="outlined"
      color={color}
    />
  );
};

export default CstStatusChip;
